/**
 * In this file, you can disable zone features which are not needed by your application.
 * 
 * For more information about these flags, refer to the documentation:
 * https://angular.io/guide/zone#configuring-zonejs
 */
(window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
(window as any).__Zone_disable_on_property = true; // disable patch onProperty
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
